<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
// import ProductService from '@/services/product'
import 'dropzone/dist/dropzone.css'; // Importe o estilo CSS do Dropzone
import Dropzone from 'dropzone'; // Importe a biblioteca Dropzone
import { API_URL, LOCALSTORAGE_TOKEN_NAME } from "../../../api-config";

Dropzone.autoDiscover = false;

export default {
  page: {
    title: "Upload de Fotos",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout },
  data() {
    return {
      title: "Upload de Fotos",
      products: [],
      product: '',
      isLoading: false,
      images: [],
      indexToRemove: null,
      files: [],
      uploadingFile: false,
      totalFiles: 0,
      uploadedCount: 0,
      failedCount: 0,
      dz: null 
    };
  },
  methods: {
    initDropzone() {
      if (this.dropzone) {
        this.dropzone.destroy();
        this.dropzone = null;
      }

      this.uploadingFile = false;
      this.totalFiles = 0;
      this.uploadedCount = 0;
      this.failedCount = 0;
      
      // Configurações do Dropzone
      const options = {
        url: `${API_URL}/products/image-upload`,
        method: 'post',
        paramName: 'file',
        headers: { 'x-token': localStorage.getItem(LOCALSTORAGE_TOKEN_NAME) || '' },

        autoQueue: false,
        autoProcessQueue: true,

        addRemoveLinks: true,
        maxFilesize: 10,
        acceptedFiles: 'image/*',
        previewsContainer: null,
        maxFiles: null,                   // ou simplesmente remova maxFiles
        uploadMultiple: false,            // envia 1 por request
        parallelUploads: 1,  
        
        dictRemoveFile: 'Remover',
        dictDefaultMessage: 'Clique ou arraste os arquivos',
        dictInvalidFileType: 'O tipo do arquivo não é válido',
        dictFileTooBig: 'O tamanho do arquivo é maior do que o máximo permitido (10 MB)',
        dictCancelUpload: 'Cancelar envio',
      };

      this.dropzone = new Dropzone('#dropzone', options);

      const refreshTotals = () => {
        // Só conta os que ainda estão na fila (não enviados)
        this.totalFiles = this.dropzone.files.filter(f =>
          f.status !== Dropzone.SUCCESS && f.status !== Dropzone.ERROR
        ).length;
      };

      this.dropzone.on('addedfile', () => {
        // Se você quiser armazenar dataUrl, habilite o createImageThumbnails (padrão true)
        // e depois dá pra ler file.dataURL (normalmente é "dataURL", não "dataUrl")
        refreshTotals();
      });

      this.dropzone.on('removedfile', () => {
        refreshTotals();
      });

      this.dropzone.on('uploadprogress', (file, progress) => {
        // progress vai de 0 a 100 do arquivo atual
        this.currentFileProgress = Math.round(progress);
      });

      this.dropzone.on('sending', () => {
        this.uploadingFile = true;
      });
      this.dropzone.on('success', (file, response) => {
        this.uploadedCount += 1;

        // Se quiser guardar retorno do backend no próprio arquivo:
        file.serverResponse = response;

        setBadge(file, 'success', 'OK');
        hideRemoveLink(file);

        // Atualiza total remanescente
        refreshTotals();
      });
      this.dropzone.on('error', (file, err) => {
        this.failedCount += 1;

        // eslint-disable-next-line no-console
        console.log(err);
        
        setBadge(file, 'error', 'ERRO');

        // mantém contagem correta
        refreshTotals();

        // opcional: log
        // console.error('Erro ao enviar', file.name, err);
      });

      this.dropzone.on('queuecomplete', () => {
        this.uploadingFile = false;
        this.currentFileProgress = 0;

        this.$toast.open('Processo concluído com sucesso');

        // this.dropzone.removeAllFiles(true);
      });

      function hideRemoveLink(file) {
        if (!file.previewElement) return;
        const removeLink = file.previewElement.querySelector('.dz-remove');
        if (removeLink) removeLink.remove(); // some de vez
      }

      function setBadge(file, type, text) {
        if (!file.previewElement) return;

        // remove badge anterior, se existir
        const existing = file.previewElement.querySelector('.dz-custom-badge');
        if (existing) existing.remove();

        const badge = document.createElement('div');
        badge.className = `dz-custom-badge dz-custom-badge--${type}`;
        badge.innerText = text;

        file.previewElement.appendChild(badge);
      }
    },

    upload() {
      this.$bvModal.hide('modal-confirm');

      const accepted = this.dropzone.getAcceptedFiles();
      if (!accepted.length) return;

      // zera contadores
      this.uploadedCount = 0;
      this.failedCount = 0;
      this.totalFiles = accepted.length;
      this.currentFileProgress = 0;

      // Enfileira tudo manualmente (como autoQueue=false)
      accepted.forEach(file => {
        if (file.status === Dropzone.ADDED) {
          this.dropzone.enqueueFile(file);
        }
      });

      // Não precisa nem chamar processQueue() — ao enfileirar com autoProcessQueue=true ele já começa
      // Mas se quiser garantir:
      this.dropzone.processQueue();
    }
  },

  mounted() {
    this.initDropzone();
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{title}}</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <div id="dropzone" class="dropzone"></div>  
            
            <!-- <form id="dz" class="dropzone dz-clickable">
              <div class="dz-message">Arraste ou clique para adicionar imagens</div>
            </form> -->
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-sm-12">
            <button type="button" class="btn btn-primary btn-rounded mb-2 mr-2" @click="$bvModal.show('modal-confirm')">
              <i class="mdi mdi-upload mr-1"></i> Enviar Fotos
            </button>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modal-confirm" title="Enviar Imagens" title-class="font-18" centered>
      <p>Confirma o upload dos arquivos?</p>

      <div slot="modal-footer">
        <b-btn variant="link" @click="$bvModal.hide('modal-confirm')">Cancelar</b-btn>
        <b-btn variant="primary" @click="upload">Enviar</b-btn>
      </div>
    </b-modal>
  </Layout>
</template>

<style lang="scss">
  .images {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;

    .image {
      display: flex;
      flex-direction: row;
      align-items: center;

      .image-group {
        flex-direction: column;
        display: flex;
        position: relative;
      }
    }

    img {
      height: 100px;
      margin: 20px 20px 10px 20px;
      min-height: 80px;
    }

    .new-image {
      // border: 2px dashed #a6b0cf !important;
      height: 140px;
      width: 140px;
      border-radius: 6px;
      color: #a6b0cf;
      // font-size: 30px;
      justify-content: center;
      flex-direction: column;
      display: flex;
      align-items: center;
      // padding: 10px;

      p {
        font-size: 10px;
        text-align: center;
        margin: 6px 0px 0px 0px;
      }

      // margin: 20px;
    }

    input[type="file"] {
      display: none;
    }
  }

  .nav-link.disabled {
    color: #e1e1e1;
  }

  .remove-image {
    position: absolute;
    right: 14px;
    background-color: #fff;
    color: red;
    height: 10px;
    width: 10px;
    top: 14px;
    padding: 15px;
    margin: 0px;
    display: flex;
    border-radius: 50%;
    /* line-height: 10px; */
    justify-content: center;
    align-items: center;
  }

  .dz-custom-badge {
    position: absolute;
    top: 8px;
    right: 8px;
    padding: 4px 8px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    color: #fff;
    z-index: 10;
  }

  .dz-custom-badge--success { background: #28a745; }
  .dz-custom-badge--error   { background: #dc3545; }

  .dz-custom-retry {
    margin-top: 8px;
    border: 0;
    border-radius: 6px;
    padding: 6px 10px;
    cursor: pointer;
    font-size: 12px;
    background: #dc3545;
    color: #fff;
  }
</style>